import essApi from "../axios/essApi";

class User {

  async register(payload) {
    return Promise.resolve(essApi.post(`users`, payload));
  }

  async getUsers(param) {
    return Promise.resolve(essApi.get(`users`));
  }

  async getAllUsersList(param) {
    return Promise.resolve(essApi.get(`users?page=${param.pageNum}&size=${param.pageSize}`));
  }

  async getRoles() {
    return Promise.resolve(essApi.get(`roles`));
  }

  async getPermissions() {
    return Promise.resolve(essApi.get(`permissions`));
  }

  async getManagers() {
    return Promise.resolve(essApi.get(`/users/getall-user/MANAGER`));
  }

  async assignManagerToEmployee(param) {
    return Promise.resolve(essApi.post(`/users/assign-manager`, param));
  }

  async getDesignations() {
    return Promise.resolve(essApi.get(`/designation`));
  }

  async assignDesignationToEmployee(param) {
    return Promise.resolve(essApi.post(`/users/assign-designation`, param));
  }

  async searchUsers(payload) {
    return Promise.resolve(essApi.post(`users/user-by-filter`, payload));
  }
  async addUser(payload) {
    return Promise.resolve(essApi.post(`/users`, payload));
  }

  async getDesignation() {
    return Promise.resolve(essApi.get(`designation`));
  }

  async getUserByFilter(reqBody) {
    return Promise.resolve(essApi.post(`/users/user-by-filter`, reqBody));
  }

  async getBusinessUnit() {
    return Promise.resolve(essApi.get(`business-unit`));
  }

  async assignBuToEmployee(param) {
    return Promise.resolve(essApi.post(`/users/assign-business-unit`, param));
  }

  async assignRoleToEmployee(param) {
    return Promise.resolve(essApi.post(`/user/assign-role`, param));
  }

  async getAllUsers() {
    return Promise.resolve(essApi.get(`/users/getall`));
  }
  async getAllUsersEmail(param) {
    return Promise.resolve(essApi.get(`/users/getemail/${param}`));
  }
  //user filter in report
  async userFilterReport(param) {
    return Promise.resolve(essApi.post(`/users/report-user-by-filter`, param));
  }


  /* For Update User Attendance Date */
  async updateUserAttendanceDate(param) {
    return Promise.resolve(essApi.post(`update-user-attendance-date`, param));
  }
  /* For Update User Attendance Date */

  /* For Update BGV Status from Excel */
  async updateBgvStatus(payload) {
    return Promise.resolve(essApi.post(`/users/update-bgv-status`, payload));
  }
  /* For Update BGV Status from Excel */

}
export default User;